import React, { useEffect, useState } from "react";
import { Icons } from "../../atoms/Icons";
import "./withdrawal-summary-modal.scss";
import { Col, Row } from "react-bootstrap";
import Buttons from "../../atoms/Buttons";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import { addCommas } from "../../helpers/helpers";
import NotFound from "../../atoms/NotFound";

const WithdrawalSummaryModal = (props) => {
  const totalCurrentAmount = props.strategies?.reduce(
    (acc, strategy) =>
      acc +
      parseFloat(
        strategy.currentValue === "" ? 0 : strategy.currentValue, // eslint-disable-line
      ),
    0, // eslint-disable-line
  );
  const totalWithdrawAmount = props.strategies?.reduce(
    (acc, strategy) =>
      acc +
      parseFloat(
        strategy.withdrawAmount === "" ? 0 : strategy.withdrawAmount, // eslint-disable-line
      ),
    0, // eslint-disable-line
  );
  const isWithdrawAtLeast95Percent =
    totalCurrentAmount > 0 && totalWithdrawAmount >= totalCurrentAmount * 0.95;
  const [confirmLocked, setConfirmLocked] = useState(false);

  useEffect(() => {
    if (!props.lumpSumsFetching) {
      setConfirmLocked(false);
    }
  }, [props.lumpSumsFetching]);

  const handleConfirmClick = () => {
    if (confirmLocked) {
      return;
    }
    setConfirmLocked(true);
    props.handleContinue();
  };

  const [Checked1, setChecked1] = useState(false);
  const [Checked2, setChecked2] = useState(
    props.strategies
      .filter((fund) => fund.category === "Self-managed")
      .every(
        (fund) =>
          fund?.withdrawAmount === "" || parseFloat(fund.withdrawAmount) === 0,
      )
      ? true
      : false,
  );
  const [showBreakdown, setShowBreakdown] = useState(false);
  const onChangeCheckbox1 = () => {
    setChecked1(!Checked1);
  };

  const onChangeCheckbox2 = () => {
    setChecked2(!Checked2);
  };

  const handleBreakdown = () => {
    setShowBreakdown(!showBreakdown);
  };

  return (
    <div className="withdrawal-summary-modal-container">
      <div className="text-end">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="withdrawal-summary-modal-body d-none d-xl-block d-lg-block d-md-block">
        <p className="heading">{props.modalTitle}</p>
        <p className="description">
          {`Income tax will be deducted from your withdrawal before it is paid to you. You will not be able to change any flexi-access income while this withdrawal is being processed. If you need to change your flexi-access income, please exit this withdrawal request and make this change first.`}
        </p>
        {isWithdrawAtLeast95Percent ? (
          <>
            <p className="description-bold">
              {`You’ve requested to withdraw more than 95% of your current account
          value.`}
            </p>
            <p className="description">
              {`Because this withdrawal is processed using fund units, the
          amount shown is an estimate. The final value may be slightly higher or
          lower due to changes in unit prices during processing.`}
            </p>
          </>
        ) : (
          ""
        )}
        <Row className="for-income-table mt-5 m-auto">
          {props.strategies
            .filter((fund) => fund.category === "For Income")
            .every(
              (fund) =>
                fund.withdrawAmount === "" ||
                parseFloat(fund.withdrawAmount) === 0,
            ) ? (
            ""
          ) : (
            <>
              <table>
                <thead>
                  <tr>
                    <th className="ps-3">For income</th>
                    <th>Withdrawal amount</th>
                    <th>Estimated amount remaining</th>
                    <th>Your drawdown income</th>
                  </tr>
                </thead>
                <tbody>
                  {props.strategies.map((strategy, index) => {
                    if (strategy.category === "For Income") {
                      return strategy.withdrawAmount === "" ||
                        parseFloat(strategy.withdrawAmount) === 0 ? (
                        ""
                      ) : (
                        <tr className="mt-3" key={index}>
                          <td className="ps-3 pt-2">{strategy.strategyName}</td>
                          <td className="ps-1 pt-2">
                            £
                            {parseFloat(strategy.withdrawAmount) !== 0 &&
                            strategy.withdrawAmount !== "" &&
                            strategy.withdrawAmount !== undefined ? (
                              <>
                                {addCommas(Math.trunc(strategy.withdrawAmount))}
                                .
                                <span className="dd-eac-pot-value-small-digit">
                                  {(strategy.withdrawAmount % 1)
                                    .toFixed(2)
                                    .substring(2)}
                                </span>
                              </>
                            ) : (
                              "0.00"
                            )}
                          </td>
                          <td className="ps-1 pt-2">
                            £{addCommas(Math.trunc(strategy.newValue))}.
                            <span className="dd-eac-pot-value-small-digit">
                              {(strategy.newValue % 1).toFixed(2).substring(2)}
                            </span>
                          </td>
                          <td className="ps-1 pt-2">
                            £{addCommas(Math.trunc(strategy.currentIncome))}.
                            <span className="dd-eac-pot-value-small-digit">
                              {(strategy.currentIncome % 1)
                                .toFixed(2)
                                .substring(2)}
                            </span>
                            <Icons
                              iconname="arrow-right-fuchsia"
                              variant="icon-sixteen-px"
                            />{" "}
                            <b>
                              £{addCommas(Math.trunc(strategy.newIncome))}.
                              <span className="dd-eac-pot-value-small-digit">
                                {(strategy.newIncome % 1)
                                  .toFixed(2)
                                  .substring(2)}
                              </span>
                              p/m
                            </b>
                          </td>
                        </tr>
                      );
                    }
                  })}
                </tbody>
              </table>
              <hr className="mt-0" />
            </>
          )}
          {props.strategies
            .filter((fund) => fund.category === "Self-managed")
            .every(
              (fund) =>
                fund.withdrawAmount === "" ||
                parseFloat(fund.withdrawAmount) === 0,
            ) ? (
            ""
          ) : (
            <>
              <table className="mt-4">
                <thead>
                  <tr>
                    <th className="ps-3">Self-managed</th>
                    <th>Withdrawal amount</th>
                    <th>Estimated amount remaining</th>
                    <th>Your drawdown income</th>
                  </tr>
                </thead>
                <tbody>
                  {props.strategies.map((strategy, index) => {
                    if (strategy.category === "Self-managed") {
                      return strategy.withdrawAmount === "" ||
                        parseFloat(strategy.withdrawAmount) === 0 ? (
                        ""
                      ) : (
                        <tr className="mt-3" key={index}>
                          <td className="ps-3 pt-2">{strategy.strategyName}</td>
                          <td className="ps-1 pt-2">
                            £
                            {parseFloat(strategy.withdrawAmount) !== 0 &&
                            strategy.withdrawAmount !== "" &&
                            strategy.withdrawAmount !== undefined ? (
                              <>
                                {addCommas(Math.trunc(strategy.withdrawAmount))}
                                .
                                <span className="dd-eac-pot-value-small-digit">
                                  {(strategy.withdrawAmount % 1)
                                    .toFixed(2)
                                    .substring(2)}
                                </span>
                              </>
                            ) : (
                              "0.00"
                            )}
                          </td>
                          <td className="ps-1 pt-2">
                            £{addCommas(Math.trunc(strategy.newValue))}.
                            <span className="dd-eac-pot-value-small-digit">
                              {(strategy.newValue % 1).toFixed(2).substring(2)}
                            </span>
                          </td>
                          <td className="ps-1 pt-2">
                            <b>
                              £{addCommas(Math.trunc(strategy.currentIncome))}.
                              <span className="dd-eac-pot-value-small-digit">
                                {(strategy.currentIncome % 1)
                                  .toFixed(2)
                                  .substring(2)}
                              </span>
                              p/m
                            </b>{" "}
                          </td>
                        </tr>
                      );
                    }
                  })}
                </tbody>
              </table>
              <hr className="mt-0" />
              <>
                <Row style={{ paddingLeft: "0px" }}>
                  <Col lg={4}>
                    <Buttons
                      name={showBreakdown ? "Hide breakdown" : "See breakdown"}
                      className="tertiary"
                      handleClick={handleBreakdown}
                    ></Buttons>
                  </Col>
                </Row>
              </>
              {showBreakdown ? (
                <>
                  <table className="mt-4">
                    <thead>
                      <tr>
                        <th className="ps-3">Fund</th>
                        <th>Withdrawal amount</th>
                        <th>Estimated amount remaining</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {props.strategies.map((strategy) => {
                        if (strategy.category === "Self-managed") {
                          return strategy.investments.map((fund, index) => {
                            return parseFloat(fund.withdrawAmount) !== 0 ? (
                              <tr className="mt-3" key={index}>
                                <td className="ps-3 pt-2">{fund.fundName}</td>
                                <td className="ps-1 pt-2">
                                  £
                                  {parseFloat(fund.withdrawAmount) !== 0 &&
                                  fund.withdrawAmount !== "" &&
                                  fund.withdrawAmount !== undefined ? (
                                    <>
                                      {Math.abs(fund.withdrawAmount - 1) < 1e-6
                                        ? ""
                                        : addCommas(
                                            Math.trunc(fund.withdrawAmount) // eslint-disable-line
                                          )}
                                      {Math.abs(fund.withdrawAmount - 1) < 1e-6
                                        ? ""
                                        : "."}
                                      <span className="dd-eac-pot-value-small-digit">
                                        {Math.abs(fund.withdrawAmount - 1) <
                                        1e-6
                                          ? "1.00"
                                          : (fund.withdrawAmount % 1)
                                              .toFixed(2)
                                              .substring(2)}
                                      </span>
                                    </>
                                  ) : (
                                    "0.00"
                                  )}
                                </td>
                                <td className="ps-1 pt-2">
                                  £{addCommas(Math.trunc(fund.balance))}.
                                  <span className="dd-eac-pot-value-small-digit">
                                    {(fund.balance % 1).toFixed(2).substring(2)}
                                  </span>
                                </td>
                                <td></td>
                              </tr>
                            ) : (
                              ""
                            );
                          });
                        }
                      })}
                    </tbody>
                  </table>
                  <hr className="mt-0" />
                </>
              ) : (
                ""
              )}{" "}
            </>
          )}
          {props.strategies
            .filter((fund) => fund.category === "For Growth")
            .every(
              (fund) =>
                fund.withdrawAmount === "" ||
                parseFloat(fund.withdrawAmount) === 0,
            ) ? (
            ""
          ) : (
            <>
              <table className="mt-4">
                <thead>
                  <tr>
                    <th className="ps-3">For growth</th>
                    <th>Withdrawal amount</th>
                    <th>Estimated amount remaining</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {props.strategies.map((strategy, index) => {
                    if (strategy.category === "For Growth") {
                      return strategy.withdrawAmount === "" ||
                        parseFloat(strategy.withdrawAmount) === 0 ? (
                        ""
                      ) : (
                        <tr className="mt-3" key={index}>
                          <td className="ps-3 pt-2">{strategy.strategyName}</td>
                          <td className="ps-1 pt-2">
                            £
                            {parseFloat(strategy.withdrawAmount) !== 0 &&
                            strategy.withdrawAmount !== "" &&
                            strategy.withdrawAmount !== undefined ? (
                              <>
                                {addCommas(Math.trunc(strategy.withdrawAmount))}
                                .
                                <span className="dd-eac-pot-value-small-digit">
                                  {(strategy.withdrawAmount % 1)
                                    .toFixed(2)
                                    .substring(2)}
                                </span>
                              </>
                            ) : (
                              "0.00"
                            )}
                          </td>
                          <td className="ps-1 pt-2">
                            £{addCommas(Math.trunc(strategy.newValue))}.
                            <span className="dd-eac-pot-value-small-digit">
                              {(strategy.newValue % 1).toFixed(2).substring(2)}
                            </span>
                          </td>
                          <td></td>
                        </tr>
                      );
                    }
                  })}
                </tbody>
              </table>
              <hr className="mt-0" />
            </>
          )}
        </Row>
        <CustomCheckbox
          defaultChecked={false}
          checked={Checked1}
          type={"checkbox"}
          label={
            "By submitting this withdrawal request you acknowledge that it will reduce the amount of money you have available for later in life or for passing on to your beneficiaries. You should weigh up your need for a payment now versus what you will need later in life to be confident you won’t run out of money."
          }
          variantName={
            "custom-checkbox mt-4 submitting-withdrawal-req-checkbox"
          }
          onChange={onChangeCheckbox1}
        />
        {props.strategies
          .filter((fund) => fund.category === "Self-managed")
          .every(
            (fund) =>
              fund?.withdrawAmount === "" ||
              parseFloat(fund.withdrawAmount) === 0,
          ) ? (
          ""
        ) : (
          <CustomCheckbox
            defaultChecked={false}
            checked={Checked2}
            type={"checkbox"}
            label={
              "You acknowledge receipt of your personal illustration and wish to proceed to make your withdrawal."
            }
            variantName={
              "custom-checkbox mt-5 submitting-withdrawal-req-checkbox"
            }
            onChange={onChangeCheckbox2}
          />
        )}
        {props.lumpSumsError && props.errorShown === true ? (
          <div className="mt-3 mb-3">
            <NotFound err={props.lumpSumsError} />
          </div>
        ) : (
          ""
        )}
        <div className="d-flex justify-content-end">
          <Buttons
            name="Cancel"
            className="secondary me-4"
            variantname="icon-sixteen-px"
            handleClick={props.handleCloseButton}
          ></Buttons>
          <Buttons
            name="Continue"
            className="primary"
            variantname="icon-sixteen-px"
            handleClick={handleConfirmClick}
            disabled={
              !Checked1 || !Checked2 || confirmLocked || props.lumpSumsFetching
            }
            lumpSumsFetching={props.lumpSumsFetching}
          ></Buttons>
        </div>
      </div>
      <div className="wd-mobile-summary-body d-block d-sm-none">
        <p className="heading">{props.modalTitle}</p>
        <Row className="summary-table mb-5">
          <Col className="mb-3">
            <table>
              <thead>
                <tr>
                  <th className="ps-4">Income</th>
                </tr>
              </thead>
              <tbody>
                {props.strategies.map((item, index) => {
                  if (item?.category === "For Income") {
                    return (
                      <tr className="mt-3" key={index}>
                        <td className="ps-4">
                          <div className="wd-mobile-fund-name">
                            {item.strategyName}
                          </div>

                          <div className="wd-mobile-allocation">
                            <Row className="mb-3">
                              <Col>
                                <span>Withdrawal amount</span>
                                <div className="wd-mobile-value">
                                  £{addCommas(Math.trunc(item.withdrawAmount))}.
                                  <span className="dd-eac-pot-value-small-digit">
                                    {(item.withdrawAmount % 1)
                                      .toFixed(2)
                                      .substring(2)}
                                  </span>
                                </div>
                              </Col>

                              <Col>
                                <span>Estimated amount remaining</span>
                                <div className="wd-mobile-value">
                                  £{addCommas(Math.trunc(item.newValue))}.
                                  <span className="dd-eac-pot-value-small-digit">
                                    {(item.newValue % 1)
                                      .toFixed(2)
                                      .substring(2)}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <span>Your drawdown income</span>
                                <div className="wd-mobile-value">
                                  £{addCommas(Math.trunc(item.currentIncome))}.
                                  <span className="dd-eac-pot-value-small-digit">
                                    {(item.currentIncome % 1)
                                      .toFixed(2)
                                      .substring(2)}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </table>
          </Col>
          <Col className="mb-3">
            <table>
              <thead>
                <tr>
                  <th className="ps-4">Self managed</th>
                </tr>
              </thead>
              <tbody>
                {props.strategies.map((item, index) => {
                  if (item?.category === "Self-managed") {
                    return (
                      <tr className="mt-3" key={index}>
                        <td className="ps-4">
                          <div className="wd-mobile-fund-name">
                            {item.strategyName}
                          </div>

                          <div className="wd-mobile-allocation">
                            <Row className="mb-3">
                              <Col>
                                <span>Withdrawal amount</span>
                                <div className="wd-mobile-value">
                                  £{addCommas(Math.trunc(item.withdrawAmount))}.
                                  <span className="dd-eac-pot-value-small-digit">
                                    {(item.withdrawAmount % 1)
                                      .toFixed(2)
                                      .substring(2)}
                                  </span>
                                </div>
                              </Col>

                              <Col>
                                <span>Estimated amount remaining</span>
                                <div className="wd-mobile-value">
                                  £{addCommas(Math.trunc(item.newValue))}.
                                  <span className="dd-eac-pot-value-small-digit">
                                    {(item.newValue % 1)
                                      .toFixed(2)
                                      .substring(2)}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <span>Your drawdown income</span>
                                <div className="wd-mobile-value">
                                  £{addCommas(Math.trunc(item.currentIncome))}.
                                  <span className="dd-eac-pot-value-small-digit">
                                    {(item.currentIncome % 1)
                                      .toFixed(2)
                                      .substring(2)}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </table>
          </Col>
          <Col className="mb-3">
            <table>
              <thead>
                <tr>
                  <th className="ps-4">Growth</th>
                </tr>
              </thead>
              <tbody>
                {props.strategies.map((item, index) => {
                  if (item?.category === "For Growth") {
                    return (
                      <tr className="mt-3" key={index}>
                        <td className="ps-4">
                          <div className="wd-mobile-fund-name">
                            {item.strategyName}
                          </div>

                          <div className="wd-mobile-allocation">
                            <Row className="mb-3">
                              <Col>
                                <span>Withdrawal amount</span>
                                <div className="wd-mobile-value">
                                  £{addCommas(Math.trunc(item.withdrawAmount))}.
                                  <span className="dd-eac-pot-value-small-digit">
                                    {(item.withdrawAmount % 1)
                                      .toFixed(2)
                                      .substring(2)}
                                  </span>
                                </div>
                              </Col>

                              <Col>
                                <span>Estimated amount remaining</span>
                                <div className="wd-mobile-value">
                                  £{addCommas(Math.trunc(item.newValue))}.
                                  <span className="dd-eac-pot-value-small-digit">
                                    {(item.newValue % 1)
                                      .toFixed(2)
                                      .substring(2)}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <span>Your drawdown income</span>
                                <div className="wd-mobile-value">
                                  £{addCommas(Math.trunc(item.currentIncome))}.
                                  <span className="dd-eac-pot-value-small-digit">
                                    {(item.currentIncome % 1)
                                      .toFixed(2)
                                      .substring(2)}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </table>
          </Col>
        </Row>
        <div className="d-block d-sm-none">
          <div className="mb-check-box">
            <CustomCheckbox
              defaultChecked={false}
              checked={Checked1}
              type={"checkbox"}
              label={
                "By submitting this withdrawal request you acknowledge that it will reduce the amount of money you have available for later in life or for passing on to your beneficiaries. You should weigh up your need for a payment now versus what you will need later in life to be confident you won’t run out of money."
              }
              variantName={
                "custom-checkbox mt-4 submitting-withdrawal-req-checkbox"
              }
              onChange={onChangeCheckbox1}
            />
          </div>
          {props.strategies
            .filter((fund) => fund.category === "Self-managed")
            .every(
              (fund) =>
                fund?.withdrawAmount === "" ||
                parseFloat(fund.withdrawAmount) === 0,
            ) ? (
            ""
          ) : (
            <div className="mb-check-box">
              <CustomCheckbox
                defaultChecked={false}
                checked={Checked2}
                type={"checkbox"}
                label={
                  "You acknowledge receipt of your personal illustration and wish to proceed to make your withdrawal."
                }
                variantName={
                  "custom-checkbox mt-5 submitting-withdrawal-req-checkbox"
                }
                onChange={onChangeCheckbox2}
              />
            </div>
          )}
          <div className="d-flex justify-content-end">
            <Buttons
              name="Cancel"
              className="secondary me-4"
              variantname="icon-sixteen-px"
              handleClick={props.handleCloseButton}
            ></Buttons>
            <Buttons
              name="Continue"
              className="primary"
              variantname="icon-sixteen-px"
              handleClick={handleConfirmClick}
              disabled={
                !Checked1 ||
                !Checked2 ||
                confirmLocked ||
                props.lumpSumsFetching
              }
              lumpSumsFetching={props.lumpSumsFetching}
            ></Buttons>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithdrawalSummaryModal;
